<template>

<div class="section-box__jelly-mobile"> 
    <div class="jelly-container-mobile"></div>

    </div>

</template>

<script>
export default {
  name: "BlobMobile",
  data() {
    return {};
  },

};
</script>



// WEBPACK FOOTER //
// src/components/small-components/MainSectionBlobMobile.vue